/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Import_Stat_StatusInputs */

const cs_import_stat_status = /** @type {(inputs: Import_Stat_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stav: ${i?.status}`)
};

const en_import_stat_status = /** @type {(inputs: Import_Stat_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status: ${i?.status}`)
};

/**
* | output |
* | --- |
* | "Status: {status}" |
*
* @param {Import_Stat_StatusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_status = /** @type {((inputs: Import_Stat_StatusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_StatusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_status(inputs)
	return cs_import_stat_status(inputs)
});